  import {
    getProveedorUsuarioById,
    getProveedorUsuarios,
    newProveedorUsuario,
  } from "../services/serviceProveedores";
  import { bajaUsuario } from "../services/serviceUsuarios";

  const dataInicial = {
    array: [],
    exito: 0,
    idProveedor: 0,
    proveedorUsuario: {},
  };
  
  const POST_PROVEEDOR_USUARIO_ADD = "POST_PROVEEDOR_USUARIO_ADD";
  const GET_PROVEEDOR_USUARIO_ALL = "GET_PROVEEDOR_USUARIO_ALL";
  const GET_PROVEEDOR_USUARIO_BY_ID = "GET_PROVEEDOR_USUARIO_BY_ID";
  const PUT_PROVEEDOR_USUARIO_ESTATUS = "PUT_PROVEEDOR_USUARIO_ESTATUS";
  const CLEAR_PROVEEDOR_USUARIO_ALL = "CLEAR_PROVEEDOR_USUARIO_ALL";
  
  export default function proveedorUsuarioReducer(state = dataInicial, action) {
    switch (action.type) {
      case PUT_PROVEEDOR_USUARIO_ESTATUS:
        return {
          ...state,
          array: action.payload.array,
          exito: action.payload.exito,
        }
      case GET_PROVEEDOR_USUARIO_BY_ID:
        return {
          ...state,
          proveedorUsuario: action.payload.proveedorUsuario
        }
      case CLEAR_PROVEEDOR_USUARIO_ALL:
        return {
          ...state,
          array: action.payload.array,
          exito: action.payload.exito,
        };
      case GET_PROVEEDOR_USUARIO_ALL:
        return { ...state, array: action.payload.array, idProveedor: action.payload.idProveedor };
      case POST_PROVEEDOR_USUARIO_ADD:
        return {
          ...state,
          exito: action.payload.exito,
          array: action.payload.array,
        };
      default:
        return state;
    }
  }
  export const bajaProveedorUsuarioAction = (idUsuario, estatus) => async (dispatch, getSate) => {
    const idProveedor = getSate().proveedoresUsuarios.idProveedor;
    const response = await bajaUsuario({idUsuario, estatus});
    const newProveedoresUsuarios = await getProveedorUsuarios({idProveedor});
    dispatch({
      type: PUT_PROVEEDOR_USUARIO_ESTATUS,
      payload: {
        array: newProveedoresUsuarios,
        exito: 1,
      },
    });
    return response;
  };
  export const altaProveedorUsuarioAction = (payload) => async (dispatch, getSate) => {
    const idProveedor = getSate().proveedoresUsuarios.idProveedor;
    const response = await newProveedorUsuario({ payload });
    const newProveedoresUsuarios = await getProveedorUsuarios({idProveedor});
    dispatch({
      type: POST_PROVEEDOR_USUARIO_ADD,
      payload: {
        array: newProveedoresUsuarios,
        exito: 1,
      },
    });
    return response;
  };

  export const obtenerProveedoresUsuariosAllAction = (idProveedor) => async (dispatch) => {
    const proveedoresUsuarios = await getProveedorUsuarios({idProveedor});
    dispatch({
      type: GET_PROVEEDOR_USUARIO_ALL,
      payload: {
        array: proveedoresUsuarios,
        idProveedor: idProveedor
      },
    });
    return proveedoresUsuarios;
  };

  export const obtnerProveedorUsuarioByIdAction = (idUsuario) => async (dispatch) =>{
    const proveedorUsuario = await getProveedorUsuarioById({idUsuario});
    dispatch({
      type: GET_PROVEEDOR_USUARIO_BY_ID,
      payload: {
        proveedorUsuario: proveedorUsuario,
      },
    });
    return proveedorUsuario;
  }
  
  export const clearState = () => (dispatch) => {
    dispatch({
      type: CLEAR_PROVEEDOR_USUARIO_ALL,
      payload: {
        dataInicial,
      },
    });
  };
  